import { appConfig } from "@/services/config";

export type AuthConnectivityMode = "online" | "offline";

/**
 * Probes Keycloak OIDC discovery (used by login fallbacks, not by the badge).
 */
export async function probeKeycloakReachable(
  oidcUrl: string = appConfig.oidcUrl,
  timeoutMs = 2500,
): Promise<boolean> {
  if (typeof navigator !== "undefined" && navigator.onLine === false) {
    return false;
  }
  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await fetch(`${oidcUrl.replace(/\/$/, "")}/.well-known/openid-configuration`, {
      method: "GET",
      cache: "no-store",
      signal: controller.signal,
    });
    return response.ok;
  } catch {
    return false;
  } finally {
    window.clearTimeout(timer);
  }
}

/**
 * Login badge / routing mode follows browser Internet connectivity only.
 * Offline = `navigator.onLine === false` (not “Keycloak unreachable”).
 */
export function resolveAuthMode(args: { readonly browserOnline: boolean }): AuthConnectivityMode {
  return args.browserOnline ? "online" : "offline";
}
